export default __webpack_public_path__ + "static/figure-inverted-triangle-reference-7dc141b2530fedac5978381a058304dc.jpg";